export function paginateList(list, pageSize) {
    return new Array(Math.ceil(list.length / pageSize))
    .fill()
    .map(_ => list.splice(0, pageSize))
}
